/**
 * Utilitario para detectar si una URL externa corresponde a un sitio de contenido para adultos
 * o plataformas de contenido exclusivo (ej. OnlyFans, Fansly, etc.)
 */

const ADULT_DOMAINS = [
  'onlyfans.com',
  'fansly.com',
  'justforfans.com',
  'loyalfans.com',
  'manyvids.com',
  'pornhub.com',
  'xvideos.com',
  'xnxx.com',
  'redtube.com',
  'xfree.com',
  'youporn.com',
  'xhamster.com',
  'spankbang.com',
  'erome.com',
  'rule34.xxx',
  'chaturbate.com',
  'stripchat.com',
  'camsoda.com',
  'livejasmin.com',
  'imlive.com',
  'myfreecams.com',
  'bongacams.com',
  'hentaihaven.red',
  'nhentai.net',
  'brazzers.com',
  'tube8.com',
  'tnaflix.com',
  'cam4.com',
  'camshub.com',
  'milfed.com',
  'beeg.com',
  'perfectgirls.com',
  'dirty.re'
];

/**
 * Limpia y obtiene el hostname de una URL
 */
function getHostname(urlStr: string): string {
  let cleaned = urlStr.trim().toLowerCase();
  if (!cleaned) return '';

  // Quitar prefijo de protocolo si existe o agregarlo para que el parser de URL funcione
  if (!/^https?:\/\//i.test(cleaned) && !/^\/\//.test(cleaned)) {
    cleaned = 'https://' + cleaned;
  } else if (/^\/\//.test(cleaned)) {
    cleaned = 'https:' + cleaned;
  }

  try {
    const parsed = new URL(cleaned);
    // Remover subdominio www. si existe
    return parsed.hostname.replace(/^www\./i, '');
  } catch {
    // Fallback simple si falla el constructor de URL (ej. enlaces relativos o rotos)
    let host = urlStr.split('/')[0];
    host = host.split(':')[0]; // Remover puerto si existe
    return host.toLowerCase().replace(/^www\./i, '');
  }
}

/**
 * Determina si una URL pertenece a un sitio para adultos
 */
export function isAdultUrl(urlStr: string): boolean {
  if (!urlStr) return false;

  const hostname = getHostname(urlStr);
  if (!hostname) return false;

  // Verifica si el hostname coincide exactamente o termina en un dominio bloqueado (ej. sub.onlyfans.com)
  return ADULT_DOMAINS.some(domain => 
    hostname === domain || hostname.endsWith('.' + domain)
  );
}
